import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './ResetPassword.css';

axios.defaults.withCredentials = true;

const ResetPassword = () => {
  // Estado para controlar el paso: 1 = Enviar email, 2 = Ingresar token y nueva contraseña
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  
  const navigate = useNavigate();

  // Envía el token al correo (llama a /forgot-password en el backend)
  const handleSendToken = async (e) => {
    e.preventDefault();
    setMensaje('');
    setError('');
    
    try {
      const response = await axios.post('http://localhost:8080/api/auth/forgot-password', { email });
      setMensaje('Se ha enviado un email con el token a tu cuenta.');
      setStep(2); // Pasa al siguiente paso para ingresar el token y la nueva contraseña
    } catch (err) {
      console.error(err);
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('Error al enviar el token.');
      }
    }
  };

  // Envía la nueva contraseña junto con el token (llama a /reset-password en el backend)
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMensaje('');
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    try {
      const response = await axios.post('http://localhost:8080/api/auth/reset-password', {
        email,
        token,
        newPassword,
        confirmPassword,
      });
      setMensaje('Contraseña actualizada correctamente. Redirigiendo a Login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      console.error(err);
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('Error al actualizar la contraseña');
      }
    }
  };

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        <h2>Restablecer Contraseña</h2>
        {step === 1 && (
          <form onSubmit={handleSendToken}>
            <label>Correo electrónico</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Enviar Token</button>
          </form>
        )}
        {step === 2 && (
          <form onSubmit={handleResetPassword}>
            <label>Correo electrónico</label>
            <input
              type="email"
              value={email}
              disabled
            />
            <label>Token</label>
            <input
              type="text"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
            />
            <label>Nueva Contraseña</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            {/* Mensaje sofisticado con los requisitos */}
            <p className="password-hint">
              La contraseña debe tener al menos 8 caracteres, incluir una letra mayúscula, una letra minúscula, 
              un número y un carácter especial (por ejemplo: ! @ # $ % ^ &amp; * _ + - = { } [ ] ; ' : ",.&lt;&gt;/?).
            </p>
            <label>Confirmar Nueva Contraseña</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button type="submit">Confirmar Nueva Contraseña</button>
          </form>
        )}
        {mensaje && <p className="success-msg">{mensaje}</p>}
        {error && <p className="error-msg">{error}</p>}
        <button onClick={() => navigate('/login')}>Volver</button>
      </div>
    </div>
  );
};

export default ResetPassword;
